import { render } from "./MerlinPure.vue?vue&type=template&id=49f6ad2a&scoped=true&ts=true"
import script from "./MerlinPure.vue?vue&type=script&lang=ts"
export * from "./MerlinPure.vue?vue&type=script&lang=ts"

import "./MerlinPure.vue?vue&type=style&index=0&id=49f6ad2a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f6ad2a"]])

export default __exports__